const payLaterAvailability = {
  '/docs/checkout/pay-later/': ['AU', 'DE', 'ES', 'FR', 'GB', 'IT', 'US'],
  '/docs/checkout/pay-later/commerce-platforms/': [
    'AU',
    'DE',
    'ES',
    'FR',
    'GB',
    'IT',
    'US',
  ],
  '/docs/checkout/pay-later/commerce-platforms/adyen/': [
    'FR',
    'GB',
    'US',
    'AU',
  ],
  '/docs/checkout/pay-later/commerce-platforms/angelleye/': [
    'AU',
    'FR',
    'GB',
    'US',
  ],
  '/docs/checkout/pay-later/commerce-platforms/bigcommerce/': [
    'AU',
    'GB',
    'US',
  ],
  '/docs/checkout/pay-later/commerce-platforms/bluepark/': ['GB'],
  '/docs/checkout/pay-later/commerce-platforms/centarro/': ['US'],
  '/docs/checkout/pay-later/commerce-platforms/commerce-vision/': ['AU'],
  '/docs/checkout/pay-later/commerce-platforms/create/': ['GB'],
  '/docs/checkout/pay-later/commerce-platforms/cubecart/': ['FR', 'US'],
  '/docs/checkout/pay-later/commerce-platforms/ekm/': ['GB'],
  '/docs/checkout/pay-later/commerce-platforms/freewebstore/': ['FR', 'GB'],
  '/docs/checkout/pay-later/commerce-platforms/genecommerce/': ['GB', 'IT'],
  '/docs/checkout/pay-later/commerce-platforms/jotform/': ['US'],
  '/docs/checkout/pay-later/commerce-platforms/magento-2/': [
    'AU',
    'ES',
    'FR',
    'GB',
    'IT',
    'US',
  ],
  '/docs/checkout/pay-later/commerce-platforms/magento-2/genecommerce/': [
    'AU',
    'ES',
    'GB',
    'IT',
    'US',
  ],
  '/docs/checkout/pay-later/commerce-platforms/magento-2/iwd/': [
    'AU',
    'ES',
    'FR',
    'GB',
    'IT',
    'US',
  ],
  '/docs/checkout/pay-later/commerce-platforms/magento-2/magento-braintree/': [
    'AU',
    'FR',
    'GB',
    'US',
  ],
  '/docs/checkout/pay-later/commerce-platforms/magento-2/magento-paypal/': [
    'FR',
  ],
  '/docs/checkout/pay-later/commerce-platforms/magento-2/paypal/': [
    'AU',
    'ES',
    'FR',
    'GB',
    'IT',
    'US',
  ],
}

export { payLaterAvailability }
